export const GET_APPOINTMENTS = 'GET_APPOINTMENTS';
